export enum AttendanceStatus {
  Attended = 'Attended',
  DidNotAttend = 'Did not attend',
  LateCancellation = 'Late cancellation',
  DidNotAttendLateCancellation = 'Did not attend, late cancellation',
}
